import { Component, OnInit, ViewChild, AfterViewInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, FormArray, Validators } from '@angular/forms';
import 'rxjs/add/operator/filter';
import { ApprovalService } from "src/app/_services/approval/approval.service";
import { LocalStorageService } from "src/app/_services/localStorage/local-storage.service";
import * as _ from 'lodash';
import { AllocationService } from 'src/app/_services/resource-allocation/allocation.service';
import { DatePipe, formatDate } from '@angular/common';
import { ColumnApi, GridApi } from 'ag-grid-enterprise';
import { Router, ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-leave-approval',
  templateUrl: './leave-approval.component.html',
  styleUrls: ['./leave-approval.component.scss']
})
export class LeaveApprovalComponent implements OnInit {
  rowData: any;
  leaveapplicationForm: FormGroup;
  userDropdownList = [];
  tenantId: string;
  userDetails: any;
  date: Date;
  TodayDate: string;
  lafduration: number;
  latduration: number;
  laduration: number;
  leaveduration: number;
  private api: GridApi;
  private columnApi: ColumnApi;
  leaveStatus: any;
  leaveId: any;

  constructor(
    private storageService: LocalStorageService,
    private ApprovalService: ApprovalService,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private allocationService: AllocationService,
    private datePipe: DatePipe,
  ) {

    this.leaveId = this.route.snapshot.paramMap.get('data');

    this.leaveapplicationForm = this.formBuilder.group({
      id: new FormControl(''),
      userId: new FormControl(''),
      leavetype: new FormControl(''),
      startDate: new FormControl(''),
      endDate: new FormControl(''),
      leaveReason: new FormControl(''),
      status: new FormControl(''),
      applicationDate: new FormControl(''),
      appliedByUserId: new FormControl(''),
      appliedByUserName: new FormControl(''),
      userIdUserName: new FormControl(''),
      applicationTitle: new FormControl(''),
      duration: new FormControl(''),
      delegatedToUserId: new FormControl(''),
      delegatedToUserName: new FormControl(''),
      approvedDate:  new FormControl(''),
      halfDay: false
    });
  }

  ngOnInit(): void {
    this.date = new Date();
    let latest_date = this.datePipe.transform(this.date, 'yyyy-MM-dd');
    this.TodayDate = latest_date;
    this.tenantId = this.storageService.get('tenantId');
    this.userDetails = JSON.parse(this.storageService.get('currentUser'));
    this.getUserList();
    this.getSelectedLeaveApplication(this.leaveId);
  }

  openLeaveApp() {
    location.href = "${this.tenantId}/dashboard/approval/leave-approval ";
  }

  getSelectedLeaveApplication(id) {
    this.ApprovalService.getSelectedLeaveApplication(id).subscribe((response: any) => {
      response.userIdUserName = response.userId+" . " +response.userIdUserName;
      response.delegatedToUserName= response.delegatedToUserId + " . "+ response.delegatedToUserName;
      this.rowData = response;
      this.leaveapplicationForm.patchValue({
        userId: response.userId + " . " +response.userIdUserName,
        leavetype: response.leavetype,
        startDate: response.startDate,
        endDate: response.endDate,
        applicationDate: response.applicationDate,
        applicationTitle: response.applicationTitle,
        appliedByUserId: response.appliedByUserId,
        appliedByUserName: response.appliedByUserName,
        delegatedToUserId: response.delegatedToUserId,
        delegatedToUserName: response.delegatedToUserName,
        duration: response.duration,
        halfDay: response.halfDay,
        leaveReason: response.leaveReason,
        status: response.status,
        approvedDate: response.approvedDate,
        userIdUserName: response.userIdUserName,
      });
      if(response.delegatedToUserName === null){
        this.leaveapplicationForm.value.delegatedToUserName = '',
        this.leaveapplicationForm.patchValue(this.leaveapplicationForm.value);
      }
      this.leaveapplicationForm.patchValue(this.rowData, { onlySelf: true });
      if(!response.approvedDate){
        this.leaveapplicationForm.value.approvedDate = this.TodayDate;
        this.leaveapplicationForm.patchValue(this.leaveapplicationForm.value);
      }
      this.leaveStatus = response.status;
    });
  }

  addleaveAppRates() {
    if(this.leaveapplicationForm.get('approvedDate').value != null) {
      this.leaveapplicationForm.value.approvedDate = this.leaveapplicationForm.get('approvedDate').value;
    } else if(this.leaveapplicationForm.get('status').value === "Approved") {
      this.leaveapplicationForm.value.approvedDate = formatDate(new Date(), 'yyyy-MM-dd', 'en-US');
    } else {
      this.leaveapplicationForm.value.approvedDate = null;
    }
    var addladata = {
      id: this.leaveapplicationForm.get('id').value,
      userId: (this.leaveapplicationForm.get('userId').value).toString().split(",")[0],
      leavetype: this.leaveapplicationForm.get('leavetype').value,
      startDate: this.leaveapplicationForm.get('startDate').value,
      endDate: this.leaveapplicationForm.get('endDate').value,
      leaveReason: this.leaveapplicationForm.get('leaveReason').value,
      status: this.leaveapplicationForm.get('status').value,
      applicationDate: this.leaveapplicationForm.get('applicationDate').value,
      applicationTitle: this.leaveapplicationForm.get('applicationTitle').value,
      appliedByUserId: this.leaveapplicationForm.get('appliedByUserId').value,
      appliedByUserName: this.leaveapplicationForm.get('appliedByUserName').value,
      delegatedToUserId: this.leaveapplicationForm.get('delegatedToUserId').value,
      delegatedToUserName: this.leaveapplicationForm.get('delegatedToUserName').value,
      duration: this.leaveapplicationForm.get('duration').value,
      halfDay: this.leaveapplicationForm.get('halfDay').value,
      userIdUserName: (this.leaveapplicationForm.get('userId').value).toString().split(",")[1],
      approvedDate:  this.leaveapplicationForm.get('approvedDate').value,
    }
    this.ApprovalService.addleaveAppRates(addladata, this.leaveapplicationForm.get('id').value).subscribe((response: any) => {
      window.alert("Updated Application Successful");
      this.backToMyLeave()
    });
  }

  backToMyLeave() {
    this.router.navigate([this.tenantId + '/dashboard/approval/leave']);
  }

  getUserList() {
    this.userDropdownList = []
    this.allocationService.getUserDetails().subscribe(response => {
      for (let item of response) {
        this.userDropdownList.push(` ${item.firstName} ${item.lastName}`)
      }
    })
  }

}
